module.exports = __webpack_public_path__ + "static/media/logo.9a3d2645.svg";